﻿import React from "react";
import PropTypes from "prop-types";
import unsafeCharRegex from "../constants/unsafeCharRegex";
import EventNote from "@material-ui/icons/EventNote";

export default class SelectInput extends React.Component {
  constructor(props) {
    super(props);

    this.onValueChange = this.onValueChange.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
  }

  testRegex(val) {
    let pattern = unsafeCharRegex;
    let regex = new RegExp(pattern);
    let test = regex.test(val);
    return test;
  }

  onValueChange(e) {
    let val = e.target.value;
    if (this.testRegex(val)) {
      e.preventDefault();
    } else {
      this.props.onChange(val);
    }
  }

  onKeyPress(e) {
    let key = e.key;
    if (this.testRegex(key)) {
      e.preventDefault();
    }
  }

  render() {
    let containerClass = "wbm-select-input animated-placeholder";
    if (this.props.displayCalendar) {
      containerClass += " display-calendar";
    }
    if (this.props.className) {
      containerClass += " " + this.props.className;
    }

    let inputClass = "form-control";
    if (this.props.isValid !== null && this.props.isValid !== undefined) {
      if (this.props.isValid) {
        inputClass += " is-valid";
      } else {
        inputClass += " is-invalid";
      }
    }
    return (
      <div className={containerClass}>
        <input
          type="text"
          id={this.props.id}
          className={inputClass}
          value={this.props.value}
          onChange={this.onValueChange}
          onKeyPress={this.onKeyPress}
          required={this.props.required}
          maxLength={this.props.maxLength ? this.props.maxLength : null}
          disabled={this.props.disabled}
          readOnly={true}
        />
        <label htmlFor={this.props.id}>{this.props.label}</label>
        {this.props.displayCalendar && (
          <EventNote
            className={
              this.props.value && this.props.value != "" ? "active" : ""
            }
          />
        )}
            <div className="invalid-feedback text">
                <span className='invalid-icon' />
                {this.props.invalidFeedback}
            </div>
      </div>
    );
  }
}

SelectInput.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  disabledWithNoStyle: PropTypes.bool,
  displayCalendar: PropTypes.bool,
  id: PropTypes.string.isRequired,
  invalidFeedback: PropTypes.string,
  isValid: PropTypes.bool,
  label: PropTypes.string,
  maxLength: PropTypes.number,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  value: PropTypes.string.isRequired,
};
